import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'
import { VUETIFY_THEMES, DEFAULT_THEME_ID, type EnterpriseThemeId } from '@/themes/enterprise'

/**
 * Vuetify with enterprise theme presets (Material, Fluent, Lightning, Fiori, Carbon, Slate, Night).
 * Active theme is switched at runtime via useTheme().global.name.
 */
export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  theme: {
    defaultTheme: DEFAULT_THEME_ID,
    themes: Object.fromEntries(
      (Object.keys(VUETIFY_THEMES) as EnterpriseThemeId[]).map((id) => [
        id,
        {
          dark: VUETIFY_THEMES[id].dark,
          colors: VUETIFY_THEMES[id].colors,
        },
      ]),
    ),
  },
  defaults: {
    VBtn: { rounded: 'lg' },
    VCard: { rounded: 'lg', elevation: 1 },
    VTextField: { variant: 'outlined', density: 'comfortable' },
    VSelect: { variant: 'outlined', density: 'comfortable' },
    VDataTable: { density: 'comfortable' },
  },
})
